import React, { useEffect, useRef, useState } from 'react';

import SvgIcon from "../../../SharedComponents/Icons";

import './index.sass';


const FiltersDropdown = ({ className, children, header, selectedFilters }) => {

  const wrapperRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);


  const handleClickOutside = (event) => {
    const wrapper = wrapperRef.current;
    const target = event.target;
    const isWrapper = wrapper && (target === wrapper || wrapper.contains(target));

    wrapper && !isWrapper && target.id !== 'filters-toggle' && setIsOpen(false);
  };


  return (
    <div className={`filters-dropdown ${isOpen ? 'open' : ''} ${className || ''}`} ref={wrapperRef}>
      <div className="filters-dropdown__toggle" onClick={() => setIsOpen(prevState => !prevState)}>
        { header }
        <div className="filters-dropdown__toggle-right">
          { selectedFilters &&
            <div className="filters-dropdown__toggle-selected-label">
              { selectedFilters.join(', ') }
            </div>
          }
          <SvgIcon name="expand_more" size={24} className="filters-dropdown__toggle-icon" />
        </div>
      </div>
      <div className="filters-dropdown__filter-wrapper">
        { children }
      </div>
    </div>
  )
};

export default FiltersDropdown;
